import React from "react";
import { ChipSelectContainer, Label, OptionsList, Option } from "./styles";

function ChipSelect({
  currentOption,
  options = [],
  label,
  disabled,
  setOption,
}) {
  return (
    <ChipSelectContainer>
      <Label>{label}</Label>
      <OptionsList>
        {options.map((option,index) => {
          return (
            <Option
              key={index}
              disabled={disabled}
              active={option.value === currentOption.value}
              onClick={() => {
                !disabled &&
                  option.value !== currentOption.value &&
                  setOption(option);
              }}
            >
              {option.text}
            </Option>
          );
        })}
      </OptionsList>
    </ChipSelectContainer>
  );
}
export default ChipSelect;
